import { useEffect, useState } from "react";

/**
 * True only once `active` has been true continuously for `delayMs`. Backs the Support panel's
 * loading-skeleton state (GFG-687, Judd owns final visuals) — a fast response must never flash a
 * skeleton, so nothing renders during the grace period.
 */
export function useDelayedFlag(active: boolean, delayMs = 250): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!active) {
      setShow(false);
      return;
    }
    const timer = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return show;
}
